
import { localTips } from '../../../mocks/relocation';

export default function LocalTipsSection() {
  return (
    <section id="tips" className="py-20 px-6 bg-stone-50 scroll-mt-32">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-teal-700 bg-teal-50 text-sm font-medium px-4 py-1.5 rounded-full mb-4">
            <i className="ri-lightbulb-line"></i>
            Insider Knowledge
          </span>
          <h2 className="text-3xl font-bold text-gray-900 mb-3">Local Tips from Roseville Residents</h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm">
            Real advice from people who&apos;ve made the move. These insider tips will help you settle in faster.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {localTips.map((tip, index) => (
            <article
              key={index}
              className="bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow group"
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-teal-50">
                  <i className={`${tip.icon} text-teal-600 text-base`}></i>
                </div>
                <span className="text-xs font-semibold text-teal-600 uppercase tracking-wide">{tip.category}</span>
              </div>

              <p className="text-sm text-gray-700 leading-relaxed mb-4">{tip.tip}</p>

              <div className="flex items-center gap-2 pt-3 border-t border-gray-50">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100">
                  <i className="ri-user-smile-line text-gray-500 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs font-medium text-gray-700">{tip.author}</p>
                  <p className="text-xs text-gray-400">Resident since {tip.since}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
